import { msg } from '@lingui/core/macro'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { titleFor } from '~/lib/route-title'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/funnel')({
  component: FunnelLayout,
  head: () => ({ meta: [{ title: titleFor(msg`Pipeline`) }] }),
})

// Pass-through layout: the kanban and the lead detail are
// child routes — mirrors `projects.tsx` / `tasks.tsx`.
function FunnelLayout() {
  return <Outlet />
}
